export default "__VITE_ASSET__CsGqmM68__"